export default "__VITE_ASSET__D6ybPXFG__ 640w, __VITE_ASSET__B3YdefO8__ 1024w, __VITE_ASSET__BcOV1jqw__ 1536w";